import styled from 'styled-components';

export const DropdownSection = styled.section`
  display: grid;
  width: 100%;
  gap: 24px;
  grid-template-columns: 1fr 1fr;
`;
